import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input, OnChanges, Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {OrderModel} from "../../../models/order.model";
import {SiteFiltersType} from "../../../../commons/types/site-filters.type";
import {LocationType} from "../../../../commons/types/location.type";
import {FulfillmentLineInfoModel} from "../../../../fulfillment/models/fulfillment-line-info.model";
import {FulfillmentTaskModel} from "../../../../fulfillment/models/fulfillment-task.model";

require('./oms-orders-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-oms-orders-table-row',
  templateUrl: './oms-orders-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'tr',
    '[class.selected]': 'isSelected'
  }
})
export class OmsOrdersTableRowComponent implements OnChanges {

  @Input() order: OrderModel;
  @Input() isSelected: boolean;
  @Input() columns: any;
  @Input() enabledDynamicColumns: any;
  @Input() enabledPackageDynamicColumns: any;
  @Input() canRecover: boolean;

  @Output() onToggleSelect = new EventEmitter<OrderModel>();
  @Output() onFilterByType = new EventEmitter<{ type: string, value: string | string[] }>();
  @Output() onSendToDispatch = new EventEmitter<string>();
  @Output() onAddNote = new EventEmitter<string>();
  @Output() onSetOrderOnHold = new EventEmitter<string>();
  @Output() onResumeOrder = new EventEmitter<string>();
  @Output() onManuallyCompleteOrder = new EventEmitter<string>();
  @Output() onEdit = new EventEmitter<string>();
  @Output() onDuplicate = new EventEmitter<string>();
  @Output() onPrintBillOfLading = new EventEmitter<string>();
  @Output() onDownloadBillOfLading = new EventEmitter<string>();
  @Output() onSendSchedulingSMSClicked = new EventEmitter<string>();
  @Output() onSendSchedulingWhatsappClicked = new EventEmitter<string>();
  @Output() onViewSchedulingLink = new EventEmitter<string>();
  @Output() onRecover = new EventEmitter<string>();
  @Output() onCancelOrder = new EventEmitter<string>();

  public fulfillmentLine: FulfillmentLineInfoModel;
  public tasks: FulfillmentTaskModel[] = [];
  public canCopyAccount: boolean;
  public canCopyOrderId: boolean;
  public canCopyOrderExternalId: boolean;
  public canCopyProNumber: boolean;
  public canFilterByAccount: boolean;


  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public locationTypes: typeof LocationType = LocationType;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.order) {
      this.fulfillmentLine = _.head(this.order?.fulfillmentLines);
      this.tasks = _.compact([this.fulfillmentLine?.pickupTask, this.fulfillmentLine?.destinationTask]);
    }
  }

}
